var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcReject(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "21px",
    viewBox: "0 0 24 21",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icReject") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.7756082,18.70499 L14.0879677,0.731987043 C13.8052262,0.27775174 13.2975664,0 12.7499632,0 C12.20236,0 11.6947002,0.277703493 11.4119586,0.731987043 L0.224417716,18.70499 C-0.0665416211,19.1724447 -0.0751578426,19.7554966 0.201955775,20.230767 C0.479069392,20.7060859 0.998881545,21 1.56237246,21 L22.4376037,21 C23.0010946,21 23.5209067,20.7060376 23.7980204,20.230767 C24.075134,19.7554483 24.0665675,19.1724447 23.7756082,18.70499 Z M12.3827169,6 C12.9879178,6 13.5,6.3531472 13.5,6.97908826 C13.5,8.88908183 13.2827544,11.6338091 13.2827544,13.5438027 C13.2827544,14.0414015 12.7551446,14.2499999 12.3827169,14.2499999 C11.8862092,14.2499999 11.4671987,14.041353 11.4671987,13.5438027 C11.4671987,11.6338091 11.25,8.88908183 11.25,6.97908826 C11.25,6.3531472 11.7465077,6 12.3827169,6 Z M12.3823576,17.2500001 C11.7353342,17.2500001 11.25,16.7240283 11.25,16.125 C11.25,15.5113516 11.7352898,15.0000001 12.3823576,15.0000001 C12.9852799,15.0000001 13.5,15.5113516 13.5,16.125 C13.5,16.7240283 12.9852799,17.2500001 12.3823576,17.2500001 Z",
    id: "icReject",
    fill: "#FF0000",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcReject);
export default __webpack_public_path__ + "static/media/icReject.fd8189ebc2ff71034049963925b05339.svg";
export { ForwardRef as ReactComponent };